import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate,  } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import { Box } from '@mui/material';
import { ThemeProvider,  } from "@mui/material/styles";

import { useForm,FormProvider } from 'react-hook-form';
import SignIn from "./pages/Login";
import SignUp from "./pages/Signup";
import { useSelector, useDispatch } from "react-redux";
import { signOut } from "./redux/actions/authActions";
import { getUser } from "./redux/actions/userActions";
import ResetPasswordForm from "./pages/ResetPassword";
import ForgotPasswordForm from "./pages/ForgotPassword";

import MainView from "./pages/MainView";
import GailView from "./pages/GailView";
import RaterHeader from "./common/RaterHeader";
import GeneralTab from './components/general/clientOther';
import GeneralQuote from './components/general/generalQuote';
import DriverSave from './components/drivers/driverSave1';
import DriverInformationList from './components/drivers/driverInformationList';
import VehicleSave from './components/cars/vehicleSave1';
import VehicleAttribute from './components/cars/VehicleAttribute';
import VehicleAdditionalAttribute from './components/cars/VehicleAdditionalAttribute';
import VehicleInformationList from './components/cars/VehicleInformationList';
import ManagePolicy from "./components/managePolicy/ManagePolicy";
import PolicyDetails from "./components/SidebarLayout/PolicyDetails/PolicyDetails";
import PolicyListing from "./components/SidebarLayout/PolicyListing/PolicyListing";
import Settings from './pages/user/Settings';
import QuoteListing from "./components/quoteListing/Listing";
import NoteSearch from "./components/notes/NoteSearch";
import MenuDropDown from "./pages/Layout/SidebarLayout/dropdown/MenuDropDown";
import CustomerListing from "./components/searchCustomer/customerListing";
import Dashboard from './components/SidebarLayout/PolicyDetails/Dashboard';
import CustomThemeSettings from './pages/user/CustomThemeSettings';
import UserProfileForm from "./components/admin/User/UserProfileForm";
import AddLocationForm from "./components/admin/AddLocationForm";
import LocationGroup from "./components/admin/LocationGroup";
import LocationManager from "./components/admin/LocationManager";
import Location from "./components/admin/Location";
import UserList from "./components/admin/User/UserList";
import CarrierGroup from "./components/admin/CarrierGroup";
import CarrierManager from "./components/admin/Carrier/CarrierManager";
import CreateCarrier from "./components/admin/CreateCarrier";
import AddInsuranceCarrier from "./components/admin/Carrier/AddInsuranceCarrier";
import Gail from "./common/Gail";
import Signupbot from "./components/bot/Signupbot";
import Botlogin from "./components/bot/Botlogin";
import BotReport from "./components/bot/BotReport";
import BotAllReport from "./components/bot/BotAllReport";
import VerifyEmail from "./common/links/VerifyEmail";
import GailLogin from "./common/GailLogin";
import EditUserProfile from "./components/admin/EditUserProfile/EditUserProfile";
import CreatePolicy from './components/SidebarLayout/CreatePolicy/CreatePolicy';
import PolicyList from './components/SidebarLayout/CreatePolicy/PolicyList';

import ChatPage from "./common/ChatPage"; 
import GlobalSearch from "./components/SidebarLayout/GlobalSearch/GlobalSearch";

import NotificationPanel from "./common/NotificationPanel";
import DashboardTaskList from "./components/SidebarLayout/PolicyDetails/DashboardTaskList";
import TaskCalendarView from './components/SidebarLayout/PolicyDetails/TaskCalenderView';
import Template from './components/SidebarLayout/Admin/Template';
import AboutUs from "./common/Footer/AboutUs";
import Careers from "./common/Footer/Careers";
import Acquisitions from "./common/Footer/Acquisitions";
import ContactUs from "./common/Footer/ContactUs";
import TermsAndConditions from "./common/Footer/TermsAndConditions";

import PrivacyPolicy from "./common/Footer/PrivacyPolicy";
import Footer from "./common/Footer/Footer";
import { useActivityTracker } from "./pages/useActivityTracker";
import PolicyInfo from "./components/SidebarLayout/PolicyDetails/PolicyInfo";
import LeadSourceReport from "./components/reports/LeadSourceReport";

import MissingDocumentReport from "./components/reports/MissingDocumentsReport";
import RaterReport from "./components/reports/RaterReport";
import QuoteTypeReport from "./components/reports/QuoteTypeReport";
import LocationGroupReport from "./components/reports/LocationGroupReport";

import TaskReport from "./components/reports/TaskReport";
import PolicyTable from "./components/reports/PolicyTable";
import QuoteStatusReport from "./components/reports/QuoteStatusReport";
import CustomerDemographicsReport from "./components/reports/CustomerDemographicsReport";

import ExpiredPolicyReport from "./components/reports/ExpiredPolicyReport";
import LastLoginReport from "./components/reports/LastLoginReport";
import LocationList from './components/admin/LocationList';
import CreateLeadForm from "./components/Lead/CreateLeadForm";
import GetAllLeads from "./components/Lead/GetAllLeads";
import CustomerCrmLead from "./components/reports/CustomerCrmLead";
import CsvImportButton from "./common/helpers/CSVImportButton";

const useStyles = makeStyles({
  mainContainer: {
    minHeight: "90vh",
  },
});
const RaterRoute = () => {
  const [view, setView] = useState(false);
  const methods = useForm();
  const classes = useStyles();
  const token = useSelector(
    (state) => state.auth?.token || sessionStorage.getItem("token")
  );
  const user = useSelector((state) => state?.user?.user);
  const roleAssigned = user?.newRole || [];
  const hasAuditorRole = roleAssigned.includes("ROLE_AUDITOR");
  const dispatch = useDispatch();
  const { SessionContinuationPopup } = useActivityTracker();

  useEffect(() => {
    if (!user && token) {
      dispatch(getUser());
    } else if (token === null) {
      dispatch(signOut());
    }
  }, [token, dispatch]);

  return (
    <>      
        {token && <RaterHeader />}
        <Box sx={{padding: 0, margin: 0}} className={classes.mainContainer}>
          <Routes>
            {!token && <Route path="/*" element={<Navigate to="/login" />} />}
            {token && <Route path="/login" element={<Navigate to="/home" />} />}
            {token && <Route path="/gaillogin" element={<Gail />} />}
            <Route path="/Gail" element={<Gail />} />
            {token && <Route path="/signup" element={<Navigate to="/home" />} />}
            {!token && <Route path="/login" element={<SignIn />} />}
            {!token && <Route path="/signup" element={<SignUp />} />}
            {!token && <Route path="/forgotPassword" element={<ForgotPasswordForm />} />}
            {!token && <Route path="/resetPassword" element={<ResetPasswordForm />} />}
            <Route path="/login" element={<SignIn />} />
            <Route path="/gaillogin" element={<GailLogin />} />

            {token && (
              <Route
                path="/home"
                element={hasAuditorRole ? <QuoteListing /> : <Dashboard />}
              />
            )}
            <Route path="/generalQuote" element={<GeneralQuote />} />
            {token && <Route path="/dashboard" element={<Dashboard />} />}
            {token && <Route path="/createpolicy" element={<CreatePolicy />} />}
            {token && <Route path="/policylist" element={<PolicyList />} />}

            <Route path="/managepolicy" element={<ManagePolicy />} />
            <Route path="/searchpolicy" element={<CustomerListing />} />
            <Route path="/policydetails" element={<PolicyDetails />} />
            <Route path="/driver" element={<DriverSave />} />
            <Route path="/driverInfo" element={<DriverInformationList />} />
            <Route path="/vehicle" element={<VehicleSave />} />
            <Route path="/vehicleAttribute" element={<VehicleAttribute />} />
            <Route path="/vehicleAdditionalAttribute" element={<VehicleAdditionalAttribute />} />
            <Route path="/vehiclelist" element={<VehicleInformationList />} />

            <Route path="/verifyEmail" element={<VerifyEmail />} />
            {token && <Route path="/mainview" element={<MainView />} />}
            <Route path="/client" element={<GeneralTab />} />
            {token &&  <Route path="/searchsavedquote" element={<QuoteListing />}  />}
            {token && <Route path="/managepolicylisting" element={<PolicyListing />} />}
            {token && <Route path="/createlead" element={<CreateLeadForm />} />}
            {token && <Route path="/allleads" element={<GetAllLeads />} />}
            {token && <Route path="/signupbot" element={<Signupbot />} />}
            {token && <Route path="/botreport" element={<BotReport />} />}
            {token && <Route path="/botallreport" element={<BotAllReport />} />}
            {token && <Route path="/signupbots" element={<Botlogin />} />}
            {token && <Route path="/customthemesettings" element={<CustomThemeSettings />} />}
            {token && <Route path="/CarrierGroup" element={<CarrierGroup />} />}
            {token && <Route path="/CreateCarrier" element={<CreateCarrier />} />}
            {token && <Route path="/Addinsurancecarrier" element={<AddInsuranceCarrier/>} />}
            {token && <Route path="/managecarrier" element={<CarrierManager />} />}
            {token && <Route path="/user-profile" element={<UserProfileForm />} />}
            {token && <Route path="/userlist" element={<UserList />} />}
            {token && <Route path="/addlocation" element={<AddLocationForm />} />}
            {token && <Route path="/locationmanager" element={<LocationManager />} />}
            {token && <Route path="/locationgrp" element={<LocationGroup />} />}
            {token && <Route path="/locationgroup" element={<Location />} />}
            {token && <Route path="/" element={<MainView setView={!view}/>} />}
            {token && <Route path="/quote" element={<MainView setView={view}/>} />}
            {token && <Route path="/quotes/:quoteId" element={<GailView setView={view}/>} />}
            <Route path="/quoteservice?tkn=''" element={<MainView setView={view}/>} />
            {token && <Route path="/mainview/:quoteId" element={<MainView />} />}
            {token &&<Route path="/settings" element={<Settings />} />}
            {token &&<Route path="/quote/listing" element={<QuoteListing />} />}
            {token && <Route path="/dropdown" element={<MenuDropDown />} />}
            {token && <Route path="/edituserprofile" element={<EditUserProfile />} />}
            {token && <Route path="/chat" element={<ChatPage />} />}
            {token && <Route path="/globalsearch" element={<GlobalSearch />} />}
            {token && <Route path="/template" element={<Template />} />}
            {token && <Route path="/about-us" element={<AboutUs />} />}
            {token && <Route path="/careers" element={<Careers />} />}
            {token && <Route path="/acquisitions" element={<Acquisitions />} />}
            {token && <Route path="/contact-us" element={<ContactUs />} />}
            {token && <Route path="/terms-and-conditions" element={<TermsAndConditions />} />}
            {token && <Route path="/PolicyInfo" element={<PolicyInfo />} />}
            {token && <Route path="/LocationList" element={<LocationList />} />}

            {token && <Route path="/privacypolicy" element={<PrivacyPolicy />} />}
            {token && <Route path="/notificationpanel" element={<NotificationPanel />} />}
            {token && <Route path="/dashboardtasklist" element={<DashboardTaskList />} />}
            {token && <Route path="/taskmanagment" element={<TaskCalendarView />} />}


            {token && <Route path="/raterreport" element={<RaterReport />} />}
            {token && <Route path="/quotetypereport" element={<QuoteTypeReport />} />}
            {token && <Route path="/locationgroupreport" element={<LocationGroupReport />} />}

            {token && <Route path="/missingdocumentreport" element={<MissingDocumentReport />} />}
            {token && <Route path="/expiredpolicyreport" element={<ExpiredPolicyReport />} />}
            {token && <Route path="/lastloginreport" element={<LastLoginReport />} />}
            {token && <Route path="/leadsourcereport" element={<LeadSourceReport />} />}
            {token && <Route path="/customerdemographicsreport" element={<CustomerDemographicsReport />} />}
            {token && <Route path="/quotestatusreport" element={<QuoteStatusReport />} />}
            {token && <Route path="/taskreport" element={<TaskReport />} />}
            {token && <Route path="/policyreport" element={<PolicyTable />} />}            
            {token && <Route path="/customercrmlead" element={<CustomerCrmLead/>} />}
            {token && <Route path="/csvimportbutton" element={<CsvImportButton/>} />}

            <Route path="/notesearch" element={ <FormProvider {...methods}><NoteSearch /></FormProvider>} />
          </Routes>
          {token &&  <Footer/>}

        </Box>
      {token && <SessionContinuationPopup />}
    </>
  );
};

export default RaterRoute;
